import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import Lottie from "lottie-react";
import trophy from '../assets/Trophy.json';
import search from '../assets/Search Empty.json'

function Result() {
  const { state } = useLocation();
  const navigate = useNavigate();

  // fallback if direct open
  if (!state) {
    return (
      <>
      <div className="main">
        <div className="main-div2">
          <div className="container mt-3">
              <Navbar />
            </div>
          <div className="container " style={{marginTop:"75%"}}>
            <div>
            <Lottie
            animationData={search}
            loop={true}
            style={{ width: 250 ,margin:"20px auto" }}
            />
            </div>
           <h5 className="text-center mt-5" style={{fontWeight:"400",color:"#979797"}}>No Result Found 😢</h5>

          </div>
          </div>
          </div>
      </>
  );
  }

  const { score, correct, wrong, total, category } = state;
  return (
    <>
      <div className="main">
        <div className="main-div">
          <div className="container mt-3">
            <div className="">
              <Navbar />
            </div>

         <div className="container text-center mt-5">

      <h3 className="" style={{color:"#ffcd40"}}>
        {category.toUpperCase()} RESULT
      </h3>

      <div className="result-card mt-4 p-4 mb-5">
        <h4>🎉 Quiz Completed</h4>
         <div>
      <Lottie
        animationData={trophy}
        loop={true}
        style={{ width: 250 ,margin:"20px auto" }}
      />
    </div>
        <h2 className="mt-3">Score: {score}</h2>

        {/* <div className="mt-3">
          <p>✅ Correct: {correct}</p>
          <p>❌ Wrong: {wrong}</p>
          <p>📊 Total Questions: {total}</p>
        </div> */}

        <button
          className="  mt-3 backbtn "
          onClick={() => navigate("/category")}
        >
          Back to Home
        </button>
      </div>

    </div>



          </div>
        </div>
      </div>
    </>
  );
}

export default Result;
